class ImageFade extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    if (!this.itemEls?.length) return

    this.setupImageFade()
  }

  setupListeners () {
    super.setupListeners()

    this.els.item.elements.forEach(itemEl => {
      this.listeners.add(itemEl, 'mouseenter', this.handleMouseEnter.bind(this))
      this.listeners.add(itemEl, 'focusin', this.handleFocus.bind(this))
    })
  }

  handleMouseEnter (event) {
    this.setCurrent(event.target)
  }

  handleFocus (event) {
    const currentItemEl = event.target.closest(this.els.item.selector)
    this.setCurrent(currentItemEl)
  }

  setCurrent (currentItemEl) {
    this.els.item.elements.forEach(itemEl => {
      itemEl.setAttribute('aria-current', false)
    })
    currentItemEl.setAttribute('aria-current', true)
  }

  setupImageFade () {
    // Loop through images and set opacity to 0, apart from the first image
    this.itemEls.forEach((itemEl, index) => {
      itemEl.style.transition = `opacity ${this.duration}ms ease`
      itemEl.style.opacity = 0

      if (index === 0) {
        itemEl.style.opacity = 1
      }
    })

    this.index = 0
    this.nextIndex = 1
    setInterval(() => {
      this.itemEls[this.index].style.opacity = 0
      this.itemEls[this.nextIndex].style.opacity = 1

      this.index++
      this.nextIndex++
    }, this.delay)
  }

  get index () {
    return this._index
  }

  set index (index) {
    const isLast = index === this.itemEls.length
    this._index = isLast ? 0 : index
  }

  get nextIndex () {
    return this._nextIndex
  }

  set nextIndex (index) {
    const isLast = index === this.itemEls.length
    this._nextIndex = isLast ? 0 : index
  }

  get itemEls () {
    return this.els?.item?.elements
  }

  get duration () {
    return this.getAttribute('data-fade-duration')
      ? Number(this.getAttribute('data-fade-duration')) * 1000
      : 500
  }

  get delay () {
    return this.getAttribute('data-fade-delay')
      ? Number(this.getAttribute('data-fade-delay')) * 1000
      : 8000
  }
}

if (!customElements.get('image-fade')) {
  customElements.define('image-fade', ImageFade)
}
